"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var fi_1 = require("react-icons/fi");
//#region Styled Components
var Card = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  background-color: ", ";\n  border: 1px solid rgba(200, 200, 200, 0.8);\n  border-radius: ", ";\n  padding: 30px;\n  box-shadow: ", ";\n  cursor: pointer;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  background-color: ",
    ";\n  border: 1px solid rgba(200, 200, 200, 0.8);\n  border-radius: ", ";\n  padding: 30px;\n  box-shadow: ", ";\n  cursor: pointer;\n"])), function (_a) {
    var done = _a.done, theme = _a.theme;
    return done ? theme.colors.lightgray : 'white';
}, function (_a) {
    var theme = _a.theme;
    return theme.borderRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadow;
});
var Title = styled_components_1.default.h3(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: left;\n  font-weight: 700;\n  font-size: 48px;\n  margin-bottom: 5px;\n"], ["\n  text-align: left;\n  font-weight: 700;\n  font-size: 48px;\n  margin-bottom: 5px;\n"])));
var TitleLine = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n"])));
var Subtitle = styled_components_1.default.h5(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: left;\n  font-weight: 500;\n"], ["\n  text-align: left;\n  font-weight: 500;\n"])));
var IconContainer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  svg {\n    color: ", ";\n    font-size: 30px;\n  }\n"], ["\n  svg {\n    color: ", ";\n    font-size: 30px;\n  }\n"
    //#endregion
])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary;
});
//#endregion
var Icons = {
    today: fi_1.FiTrendingUp,
    last7days: fi_1.FiBarChart,
    last30days: fi_1.FiBarChart2,
    alltime: fi_1.FiList
};
var DashboardCard = function (_a) {
    var title = _a.title, description = _a.description, type = _a.type, onClick = _a.onClick;
    var Icon = Icons[type];
    return (jsx_runtime_1.jsxs(Card, __assign({ onClick: onClick }, { children: [jsx_runtime_1.jsxs(TitleLine, { children: [jsx_runtime_1.jsx(Title, { children: title }, void 0),
                    jsx_runtime_1.jsx(IconContainer, { children: jsx_runtime_1.jsx(Icon, {}, void 0) }, void 0)] }, void 0),
            jsx_runtime_1.jsx(Subtitle, { children: description }, void 0)] }), void 0));
};
exports.default = DashboardCard;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=DashboardCard.js.map